import React, { Component } from "react"
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap"
import { map } from "lodash"

//i18n
import i18n from "../../../i18n"
import { withTranslation } from "react-i18next"

import languages from "../../../common/languages"

import { getItemFromLocalStorage,setItemOnLocalStorage } from "../../../helpers/utils"

class LanguageDropdown extends Component {
  constructor(props) {
    super(props)
    this.state = {
      menu: false,
      selectedLang: "en",
    }
  }

  componentDidMount() {
    const currentLanguage = getItemFromLocalStorage("I18N_LANGUAGE")
    this.setState({ selectedLang: currentLanguage })
  }

  changeLanguageAction = lang => {
    //set language as i18n
    i18n.changeLanguage(lang)
    setItemOnLocalStorage("I18N_LANGUAGE", lang)
    this.setState({ selectedLang: lang })
  }

  toggle = () => {
    this.setState(prevState => ({
      menu: !prevState.menu,
    }))
  }

  render() {
    const { selectedLang, menu } = this.state

    return (
      <React.Fragment>
        <Dropdown isOpen={menu} toggle={this.toggle} className="d-inline-block cursor-pointer">
          <DropdownToggle className="btn header-item waves-effect" tag="button">
            <img
              src={languages[selectedLang].flag}
              alt="Vertace"
              height="16"
              className="me-1"
            />
            <span className="align-middle">
              {languages[selectedLang].label}
            </span>
          </DropdownToggle>
          <DropdownMenu className="language-switch" end>
            {map(Object.keys(languages), key => (
              <DropdownItem
                key={key}
                onClick={() => this.changeLanguageAction(key)}
                className={`notify-item ${selectedLang === key ? "active" : "none"
                  }`}
              >
                <img
                  src={languages[key].flag}
                  alt="Vertace"
                  className="me-1"
                  height="12"
                />
                <span className="align-middle">{languages[key].label}</span>
              </DropdownItem>
            ))}
          </DropdownMenu>
        </Dropdown>
      </React.Fragment>
    )
  }
}

export default withTranslation()(LanguageDropdown)
